import React from 'react';
import { Upload, Button, message } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import { Storage } from 'aws-amplify';
import _ from 'lodash';



const dummyRequest = ({ file, onSuccess }) => {
    setTimeout(() => {
        onSuccess("ok");
    }, 0);
}

export default function UploadFiles(props) {
    const { form, eventID, spinOn, setSpinnerText } = props

    const uploadProps = {
        // maxCount: 1,
        multiple: true,
        customRequest: dummyRequest,

        name: 'upload',
        headers: {
            authorization: 'authorization-text',
        },
        onChange(info) {
            if (info.file.status === 'uploading') {
                spinOn(true)
                setSpinnerText("Nahrávám soubory...")
            }
            if (info.file.status !== 'uploading') {
                const flName = `${info.file.name.replace(/[^a-zA-Z0-9.-]/g, '')}`
                let reader = new FileReader();
                // set callback
                reader.onload = async (e) => {
                    // console.log('onload', info.file);
                    const data = e.target.result
                    const fullFlName = `${info.file.uid}-${flName}`
                    await Storage.put(`${eventID}/${fullFlName}`, data,
                        {
                            contentType: info.file.originFileObj.type
                        })
                    const currentFIleList = form.getFieldValue('files') || []
                    form.setFieldsValue({
                        files: [...currentFIleList, fullFlName],
                        // filesBucket: `${Storage._config.AWSS3.bucket}`
                    })
                    const allDone = _.every(info.fileList.map(el => el.status == "done"))
                    if (allDone) {
                        spinOn(false)
                    } else {
                        const currentfl = form.getFieldValue('files') || []
                        console.log({ allDone, currentfl })
                    }
                }
                reader.readAsArrayBuffer(info.file.originFileObj);
            }

            if (info.file.status === 'done') {
                console.log("file done")
            } else if (info.file.status === 'error') {
                // message.error(`${info.file.name} file upload failed.`);
                console.error(`error uploading file `, info.file)
                message.error("Chyba u nahrávání")
            }
        },
    };

    return (
        <Upload {...uploadProps}>
            <Button type="dashed"
                icon={<UploadOutlined />}
            > Nahrát dokumenty </Button>
        </Upload >
    )
}
